import Component from '@glimmer/component';
import { eq } from 'ember-truth-helpers';
import CharacterAvatar from './character-avatar';

// Renders one "Most Played Heroes" table (header + single hero row).
// Args:
//   @hero - object with:
//     image, alt, color, name, role,
//     timePlayed,
//     record       - array of strings rendered as highlighted values joined by ' / ',
//     medals,
//     winRate      - { value, tooltip? } for the Win Rate cell,
//     onFire       - { value, tooltip? } for the On Fire cell,
//     lastColLabel - 'Healing' | 'Damage',
//     lastCol      - string for the final cell.
//   A tooltip is { title, direction: 'up' | 'down', value } and renders the
//   ew2-lineups-tooltip cell with the matching svg icon + percentage.
export default class HeroStatTable extends Component {
  <template>
    <div class='table lineups most-played'>
      <div class='table-row-header big bordered colored'>
        <div class='table-row-header-item left'>
          <p class='table-row-header-title'>Hero / Role</p>
        </div>
        <div class='table-row-header-item padded-big'>
          <p class='table-row-header-title'>Time Played</p>
        </div>
        <div class='table-row-header-item padded-big'>
          <p class='table-row-header-title'>Record</p>
        </div>
        <div class='table-row-header-item padded-big'>
          <p class='table-row-header-title'>Medals</p>
        </div>
        <div class='table-row-header-item padded-big'>
          <p class='table-row-header-title'>Win Rate</p>
        </div>
        <div class='table-row-header-item padded-big'>
          <p class='table-row-header-title'>On Fire</p>
        </div>
        <div class='table-row-header-item padded-big'>
          <p class='table-row-header-title'>{{@hero.lastColLabel}}</p>
        </div>
      </div>
      <div class='table-rows no-color'>
        <div class='table-row big'>
          <div class='table-row-item'>
            <div class='team-info-wrap medium'>
              <CharacterAvatar @image={{@hero.image}} @alt={{@hero.alt}} @color={{@hero.color}} />
              <div class='team-info'>
                <p class='team-name'>{{@hero.name}}</p>
                <p class='team-country'>{{@hero.role}}</p>
              </div>
            </div>
          </div>
          <div class='table-row-item'>
            <p class='table-text bolder'>{{@hero.timePlayed}}</p>
          </div>
          <div class='table-row-item'>
            <p class='table-text bolder'>{{#each @hero.record as |value i|}}{{#if (eq i 0)}}{{else}}
                /
              {{/if}}<span class='highlight'>{{value}}</span>{{/each}}</p>
          </div>
          <div class='table-row-item'>
            <p class='table-text bolder'>{{@hero.medals}}</p>
          </div>
          {{#if @hero.winRate.tooltip}}
            <div class='table-row-item ew2-lineups-tooltip' data-title={{@hero.winRate.tooltip.title}}>
              <p class='table-text bolder'>
                {{#if (eq @hero.winRate.tooltip.direction 'up')}}
                  <svg class='plus-icon rate-up'>
                    <use href='#svg-plus-big'></use>
                  </svg>
                {{else}}
                  <svg class='minus-cc-icon rate-down'>
                    <use href='#svg-minus-cc'></use>
                  </svg>
                {{/if}}
                {{@hero.winRate.value}}
              </p>
            </div>
          {{else}}
            <div class='table-row-item'>
              <p class='table-text bolder'>{{@hero.winRate.value}}</p>
            </div>
          {{/if}}
          {{#if @hero.onFire.tooltip}}
            <div class='table-row-item ew2-lineups-tooltip' data-title={{@hero.onFire.tooltip.title}}>
              <p class='table-text bolder'>
                {{#if (eq @hero.onFire.tooltip.direction 'up')}}
                  <svg class='plus-icon rate-up'>
                    <use href='#svg-plus-big'></use>
                  </svg>
                {{else}}
                  <svg class='minus-cc-icon rate-down'>
                    <use href='#svg-minus-cc'></use>
                  </svg>
                {{/if}}
                {{@hero.onFire.value}}
              </p>
            </div>
          {{else}}
            <div class='table-row-item'>
              <p class='table-text bolder'>{{@hero.onFire.value}}</p>
            </div>
          {{/if}}
          <div class='table-row-item'>
            <p class='table-text bolder'>{{@hero.lastCol}}</p>
          </div>
        </div>
      </div>
    </div>
  </template>
}
